<template>
    <div>
	<div class="list-group no-border border-radius-2 mb-3">
		<div class="list-group-item list-group-item-primary d-flex align-items-center justify-content-between">
			<strong>{{ $t('curricula') }}</strong>
            <div v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
                <button
                    class="btn btn-outline-secondary btn-sm mr-2"
                    @click="$emit('explore')"
                >
                    {{ $t('explore') }} <b-icon icon="search" class="ml-1" />
                </button>
                <button class="btn btn-primary btn-sm" v-if="!new_root" @click="new_root = true;">{{ $t('new') }}</button>
                <button class="btn btn-danger btn-sm" v-else @click="new_root = false;">{{ $t('cancel') }}</button>
            </div>
		</div>
        <div
            class="list-group-item"
            v-for="(item, index) in curricula"
            :key="`${index}`"
        >
            <div class="mr-4 mb-0">
                <h3 class="mb-0">
                     <router-link class="link-bare" :to="`curriculum-mapping/node/${item.id}/graph`">{{item.title}}</router-link>
                </h3>
                <p v-if="item.note">{{ item.note }}</p>
            </div>
        </div>
	</div>
    <div v-if="new_root" class="card mb-2">
        <h4 class="card-header">{{ $t('new-curriculum') }}</h4>
        <div class="card-body">
            <TextInput 
                :label="$t('title')" 
                v-model="node.title" 
            />
            <TextAreaInput 
                :label="$t('notes')" 
                v-model="node.note" 
            />
            <button 
                class="btn btn-secondary float-right" 
                @click="saveRoot" 
                :disabled="!node.title"
            >
                {{ $t('add') }}
            </button>
        </div>
    </div>
    </div>
</template>

<script>


export default {
	components: {

	},
    props: {
        curricula: Array,
    },
    data() {
    	return {
    		selected: false,
            node: {},
            new_root: false,

    	}
    },
	mounted() {
	},
	methods: {
		selectItem: function(){
			this.selected = !this.selected;
		},
        saveRoot(){
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/save`,{
                method: "post",
                data: this.node
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.curricula.push(this.node)
                    this.new_root = false
				} else {
					this.$log.info.call(this, status)
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
        },
         openDeleteDialog(item) {
            this.selectedItem = item;

            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t('delete-{e}-warning',{e: this.$t('curriculum')}),
                cancelBtn: true,
                confirmCallBack: this.removeItem,
            })
        },
        removeItem() {
            if (!this.selectedItem) return ;
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/delete`, {
                method: 'POST',
                data: { 
                    id: this.selectedItem.id 
                }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error deleting curriculum')
                this.curricula = this.curricula.filter(el => el.id !== this.selectedItem.id)
            }).catch(err => {
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-delete-{e}',{e:this.$t('curriculum')}),
                })
            }).finally(() => {
                this.selectedItem = undefined
            })
        }
	}
};
</script>
